import { IconButton } from '@mui/material';
import { User, UserData } from '@/entities/User';
import { Typography } from '@/shared/ui/Typography';
import { formatPhoneNumber } from './formatPhoneNumber';
import { getAgreementDaysLeft } from './getAgreementDaysLeft';
import CopyIcon from '@/shared/assets/icons/icon-copy.svg?react';
import cls from '../ui/Info.module.scss';

type Props = {
    user: User;
    userData: UserData;
};

export const getAgreementDataItems = ({ user, userData }: Props) => {
    if (!user.agreemtId) {
        return null;
    }

    const agreementDaysLeft = getAgreementDaysLeft({ startDate: user.insStartDate, endDate: user.insEndDate });

    const onCopyClick = () => {
        if (user.agreemtId) {
            navigator.clipboard.writeText(user.agreemtId);
        }
    };

    return {
        title: 'Информация по договору',
        description: (
            <div className={cls.documentsContainer}>
                <div className={cls.documentsItem}>
                    <Typography className={cls.documentsItemTitle} as="p" variant="text_12_gray">
                        Застрахованное лицо
                    </Typography>
                    <p className={cls.value}>
                        {userData.secondName} {userData.firstName} {userData.middleName}
                    </p>
                </div>
                <div className={cls.documentsItem}>
                    <Typography className={cls.documentsItemTitle} as="p" variant="text_12_gray">
                        Номер договора
                    </Typography>
                    <p className={cls.value}>{user.agreemtId}</p>
                    <div className={cls.action}>
                        <IconButton type="button" onClick={onCopyClick}>
                            <CopyIcon />
                        </IconButton>
                    </div>
                </div>
                <div className={cls.documentsItem}>
                    <Typography className={cls.documentsItemTitle} as="p" variant="text_12_gray">
                        Срок действия договора
                    </Typography>
                    <p className={cls.value}>
                        {user.insStartDate} - {user.insEndDate}
                    </p>
                    <span className={cls.daysAmountLabel}>до конца действия полиса {agreementDaysLeft} дней</span>
                </div>
                <div className={cls.documentsItem}>
                    <Typography className={cls.documentsItemTitle} as="p" variant="text_12_gray">
                        Номер телефона
                    </Typography>
                    <p className={cls.value}>{formatPhoneNumber(userData.phoneNumber)}</p>
                </div>
            </div>
        ),
    };
};
